module.exports = __webpack_public_path__ + "static/img/stonewall-inn-gives-back-initiative@2x.e1ed9ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/stonewall-inn-gives-back-initiative@2x.png
// module id = G+a2
// module chunks = 0